/** User-facing product name (override with REACT_APP_DISPLAY_NAME at build time). */
export const APP_DISPLAY_NAME = (
  process.env.REACT_APP_DISPLAY_NAME ?? 'Ayogn'
).trim();

export const APP_TAGLINE = 'Where Celebrations Begin';

export const pageTitle = (section?: string): string =>
  section ? `${APP_DISPLAY_NAME} — ${section}` : `${APP_DISPLAY_NAME} — ${APP_TAGLINE}`;
